module.exports = __webpack_public_path__ + "static/media/5FEDE4.5fd09876.svg";